import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	clockIcon: {
		width: "16px",
		height: "16px",
		color: colors.gray[700],
		opacity: "0.5",
		marginRight: "10px"
	},
	groupIcon: {
		color: colors.gray[700],
		fontSize: 14,
		padding: "4px 16px",
		backgroundColor: themeColors.getPrimaryColor()
	},
	lastUpdatedUserName: {
		display: "block",
		minWidth: 0,
		maxWidth: "100%",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	},
	lastUpdatedUserContainer: {
		minWidth: 0,
		flex: 1,
		overflow: "hidden"
	}
}))

export default useStyles
